import React from 'react';
import { Chip } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { conversationHistoryTimezone, formatAgentRunDuration } from '../utils/dateutils';
import { applicationType, ApplicationType } from '../utils/constants';

interface EntityTimestampSectionProps {
    entityNumber: string;
    agentName: string;
    duration: number;
    timestamp?: string;
    isModal?: boolean;
    onFullScreenClick?: () => void;
    onRefresh?: () => void;
}

export const EntityTimestampSection: React.FC<EntityTimestampSectionProps> = ({
    entityNumber,
    agentName,
    duration,
    timestamp,
    isModal = false,
    onFullScreenClick,
    onRefresh
}) => {
    return (
        <div className="flex items-center gap-3 mb-2 mt-3">
            <div className="flex flex-col gap-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-x-2 gap-y-1 min-w-0">
                    <Chip
                        variant="flat"
                        size="sm"
                        className="bg-default-200"
                        style={{ fontSize: '14px' }}
                    >
                        Entity: {entityNumber}
                    </Chip>
                    {timestamp && (
                        <div className="flex items-center gap-1">
                            <Icon icon="mdi:clock-outline" className="text-default-400" style={{ width: '14px', height: '14px', flexShrink: 0 }} />
                            <span className="text-sm">
                                { conversationHistoryTimezone(timestamp)}
                            </span>
                        </div>
                    )}
                </div>
                {duration > 0 && (
                    <div className="flex items-center gap-1 ml-1.5 mt-0.5">
                        <span className="text-sm">Duration: </span>
                        <span className="text-sm">
                            {formatAgentRunDuration(duration)}
                        </span>
                    </div>
                )}
            </div>
            {!isModal && (onFullScreenClick || onRefresh) && (
                <div className="absolute top-3 right-12 z-10 flex">
                    {onFullScreenClick && applicationType() !== ApplicationType.BROWSER_EXTENSION && (
                        <button
                            type="button"
                            onClick={onFullScreenClick}
                            title="View Full Screen"
                            className="p-2 hover:bg-default-200 rounded-full"
                        >
                            <Icon icon="mdi:fullscreen" className="text-default-500 w-5 h-5" />
                        </button>
                    )}
                    {onRefresh && (
                        <button
                            type="button"
                            onClick={onRefresh}
                            title="Refresh"
                            className="p-2 hover:bg-default-200 rounded-full"
                        >
                            <Icon icon="mdi:refresh" className="text-default-500 w-5 h-5" />
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
